import momentJalaali from "moment-jalali";
import { Button, Col, FormControl, FormGroup, Modal, Row } from "react-bootstrap";
import { ColumnsGap, Search, Toggle2On } from "react-bootstrap-icons";
import { getSerialListForSwap, swapSerial } from "../../store/api/GuaranteeApi";
import { useRef, useState } from "react";
import BihamtaTable from "../../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faToggleOff } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { setDialog, setErrorDialog } from "../../../store/api/CommonFunctions";
import NewNumberInput from "../../../Components/NewNumberInput";

const ModalSwapSerial = (props) => {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const { serviceInfo, setServiceInfo, show } = popData;
    const [cardList, setCardList] = useState(null);
    const [customerDiff, setCustomerDiff] = useState({ CustomerInDebtForSwap: true });
    const [currentRow, setCurrentRow] = useState(null);
    const resultTable = useRef();
    const lastSelectedRowIndex = useRef(0);
    const searchData = useRef({});
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "مارک محصول", colName: "ProductHolder" },
        { colTitle: "نام/نوع محصول", colName: "ProductName" },
        { colTitle: "مدل محصول", colName: "ProductModel" },
        { colTitle: "شماره سریال", colName: "ProductSerial", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "انبار", colName: "StorageName" }
    ]
    function rowClick(row) {
        if (lastSelectedRowIndex.current > 0) {
            resultTable.current.rows[lastSelectedRowIndex.current].className = "resultTableRow";
        }
        lastSelectedRowIndex.current = row.RowIndex + 1;
        resultTable.current.rows[row.RowIndex + 1].className = "selectedResultTableRow";
        const { e, target, ...selected } = row;
        setCurrentRow(selected);
    }
    function submitSwap() {
        if (!currentRow?.ProductID) {
            return;
        }
        const onSwap = (res) => {
            if (res.Data) {
                setServiceInfo({
                    ...serviceInfo,
                    NewProductID: currentRow.ProductID,
                    NewGuaranteeCardNo: currentRow.GuaranteeCardNo,
                    NewProductSerial: currentRow.ProductSerial,
                    NewProductName: currentRow.ProductName,
                    NewProductModel: currentRow.ProductModel,
                    NewProductHolder: currentRow.ProductHolder,
                    CustomerInDebtForSwap: customerDiff.CustomerInDebtForSwap,
                    SwapPriceDifference: customerDiff.SwapPriceDifference,
                    PSwapDate: momentJalaali().local("en").format("jYYYY/jMM/jDD")
                });
                close();
            }
            else {
                setErrorDialog(dispatch, res.Error, "تعویض محصول");
            }
        }
        const swap = () => {
            const data = {
                ServiceType: serviceInfo.ServiceType,
                ServiceID: serviceInfo.ServiceID,
                DamagedProductID: serviceInfo.ProductID,
                DamagedProductSerial: serviceInfo.SerialNumber,
                DamagedProductName: serviceInfo.ProductName,
                DamagedProductModel: serviceInfo.ProductModel,
                NewProductID: currentRow.ProductID,
                NewGuaranteeCardNo: currentRow.GuaranteeCardNo,
                NewProductSerial: currentRow.ProductSerial,
                NewProductHolderID: currentRow.HolderID,
                NewProductName: currentRow.ProductName,
                NewProductModel: currentRow.ProductModel,
                GuaranteeCardID: serviceInfo.GuaranteeCardID,
                CustomerInDebtForSwap: customerDiff.CustomerInDebtForSwap,
                SwapPriceDifference: customerDiff.SwapPriceDifference,
                SourceStorageID: currentRow.StorageId
            }
            swapSerial(data, onSwap);
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'تعویض محصول ',
            dialogText: 'آیا از تعویض محصول مطمئن هستید؟',
            okOperation: swap
        }));
    }
    function search(e) {
        if (e?.key && e.key !== "Enter") {
            return;
        }
        getSerialListForSwap(searchData.current.SerialNumber, setCardList);
    }

    function close() {
        setCustomerDiff({ CustomerInDebtForSwap: true });
        setCurrentRow(null);
        lastSelectedRowIndex.current = 0;
        setPopData({
            show: false
        })
    }
    return (
        <Modal size="lg" show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faToggleOff} size="lg" />&nbsp;
                    جایگزینی محصول
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <FormGroup className="col-md-6">
                    <FormControl placeholder="شماره سریال" onChange={e => searchData.current.SerialNumber = e.target.value} onKeyDown={search} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                    <Button className="btn-input-tiny" style={{ top: 3, left: 3 }} onClick={search}><Search size={22} /></Button>
                </FormGroup>
                <BihamtaTable columns={tableCols} dataList={cardList} maxHeight={335} rowClick={rowClick} tableRef={resultTable} style={{ whiteSpace: "nowrap" }} />
                <Row className="rowBorder">
                    <Col md={4} className="form-group">
                        <label style={{ color: "#0d00ff" }}>اختلاف هزینه جایگزینی: </label>
                        <NewNumberInput onChange={e => customerDiff.SwapPriceDifference = e.target.value} />
                    </Col>
                    <Col md={4} className="form-group">
                        <label style={{ color: "#0d00ff" }}>مشتری بدهکار شود یا بستانکار:</label>
                        <select className="form-control" onChange={e => customerDiff.CustomerInDebtForSwap = e.target.value}>
                            <option value={true} style={{ color: "red" }} >بدهکار شود</option>
                            <option value={false} style={{ color: "green" }}>بستانکار شود</option>
                        </select>
                    </Col>
                    <Col md={4} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "2px" }}>
                        <Button className="group-Btn" variant="info" onClick={submitSwap}><Toggle2On size={18} />&nbsp;جایگزین شود</Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSwapSerial;